import { Control, Controller } from 'react-hook-form';
import { realisation as rules } from 'further-ui/validations';
import { AllocationRule } from 'further-types/lp/allocations';
import NumberInput from 'further-ui/components/NumberInput';

type Props = {
  considerationIndex: number;
  allocationIndex: number;
  control: Control<rules.CreateRealisationFormValues>;
  setInvestorAllocations: (considerationIndex: number) => void;
  setInvestorAllocationType: (params: {
    considerationIndex: number;
    investmentId: string;
    newAllocationType: AllocationRule;
  }) => void;
  investmentId: string;
};

const AllocationPercentageCell: React.FC<Props> = ({
  considerationIndex,
  allocationIndex,
  control,
  setInvestorAllocations,
  setInvestorAllocationType,
  investmentId,
}) => {
  return (
    <Controller
      control={control}
      name={`consideration.${considerationIndex}.investorAllocations.${allocationIndex}.allocationPercentage`}
      render={({ field: { ref: _ref, onChange, ...rest } }) => (
        <NumberInput
          {...rest}
          onChange={(value) => {
            onChange(value ?? 0);
            setInvestorAllocations(considerationIndex);
            setInvestorAllocationType({
              considerationIndex,
              investmentId,
              newAllocationType: AllocationRule.Manual,
            });
          }}
          placeholder="0"
          decimals={3}
          fullWidth
          showPercentSuffix
          min={0}
          max={100}
          size="small"
        />
      )}
    />
  );
};

export default AllocationPercentageCell;
